import WidgetInternetUsersByRegion from "./widget-internet-users-by-region";

export default WidgetInternetUsersByRegion;